






























import {
  Component, Prop, Vue, PropSync,
} from 'vue-property-decorator';
@Component({})
export default class UserFilterDropdown extends Vue {
  @Prop() public items!: any;

  @Prop() public label!: any;

  @PropSync('search') searchSync!: any;

  public clearItems() {
    this.$emit('clear');
  }
}
